<template>
 <element>
     <!--<panel label="证件图片" class="zhengjianxinxi">
       <photo-browser v-model="customerDetail.ix__extGuarantorIDFront" label="担保人身份证正面"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorIDBack" label="担保人身份证反面"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorSpouseIDFront" label="担保人-配偶身份证正面"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorSpouseIDBack" label="担保人-配偶身份证反面"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorMarriageCert" label="担保人结婚证明"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorHouseholdRegBook1" label="担保人户口本主页"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorHouseholdRegBook2" label="担保人户口本"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorHouseholdRegBook3" label="担保人-配偶户口本"/>
      &lt;!&ndash; <photo-browser v-model="customerDetail.ix__extGuarantorCompanyLicense" label="担保人营业执照"/>&ndash;&gt;
       <photo-browser v-model="customerDetail.ix__extGuarantorRoadLicense" label="担保人道路运输许可证"/>
     &lt;!&ndash;  <photo-browser v-model="customerDetail.ix__extGuarantorBizIC" label="担保人-法人代表身份证"/>&ndash;&gt;
     </panel>
     <panel label="资产证明" class="zhengjianxinxi">
       <photo-browser v-model="customerDetail.ix__extGuarantorPropertyCert" label="担保人房产证"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorRentalAgreement" label="担保人-租屋协议"/>
       <photo-browser v-model="customerDetail.ix__extGuarantorShareholdResolution" label="担保人-股东决议"/>
     </panel>
     <panel label="相关证明" class="zhengjianxinxi">
       <photo-browser v-model="customerDetail.ix__extGuarantorAppearancePhoto" label="担保人夫妻双方现场照"/>
      &lt;!&ndash; <photo-browser v-model="customerDetail.ix__extGuarantorCompanyPhoto1" label="担保人-公司室内环境"/>&ndash;&gt;
     </panel>-->
   <panel>公司担保</panel>
   <panel>
     <form-build
       :form-data="customerDetail"
       :form-columns="customerDetailFormColumns"
       class="formTable"
     />
   </panel>
   <panel label="证件图片" class="zhengjianxinxi">
     <photo-browser v-model="customerDetail.ix__extCompanyLicense" label="营业执照"/>
     <photo-browser v-model="customerDetail.ix__extCompanyBizRepIC" label="法人代表身份证"/>
     <photo-browser v-model="customerDetail.ix__extCompanyRoadLicense" label="道路运输许可证"/>
     <photo-browser v-model="customerDetail.ix__extGuarantorCompanyBankPermit" label="开户许可证"/>
     <photo-browser v-model="customerDetail.ix__extGuarantorMarriageCert" label="担保人结婚证明"/>
   </panel>
   <panel label="资产证明" class="zhengjianxinxi">
     <photo-browser v-model="customerDetail.ix__extGuarantorRentalAgreement" label="租屋协议"/>
     <div class="zhenjianyyzz zhenjianyyzz2"> <file-upload  v-model="customerDetail.ix__extGuarantorShareholdResolution" :editable="false" ></file-upload>抵押合同</div>
   </panel>
   <panel label="相关证明" class="zhengjianxinxi">
     <photo-browser v-model="customerDetail.ix__extGuarantorCompanyPhoto1" label="公司室内环境"/>
   </panel>
 </element>
</template>

<script>
  import PhotoBrowser from "../../components/PhotoBrowser";
  import moment from 'moment'
  export default {
    name: "CustomerDetailGuarantorComponent",
    components: {PhotoBrowser},
    data() {
      return {
        customerDetailFormColumns: [
          {
            label: '公司名称',
            field: 'ix__extGuarantorCompanyName',
          },
          {
            label: '联系方式',
            field: 'ix__extGuarantorCompanyContactNo',
          },

          {
            label: '注册时间',
            field: 'ix__extGuarantorCompanyRegDate',
            formatter: function(r,v) {
              if(v){
                return moment(v).format('YYYY-MM-DD')
              }else{
                return ''
              }

            },
          },
          /* {
             label: '期限/年月',
             field: 'vehicle__lifespan',
           },*/
          {
            label: '法人代表',
            field: 'ix__extGuarantorCompanyBizRep',
          },
          {
            label: '公司地址',
            field: 'ix__extGuarantorCompanyAddress',
            span:24,
          },

        ]
      }
    },
    props:{
      value: {
        type: Object
      }
    },
    computed: {
      customerDetail: {
        get: function () {
          return this.value
        },
        set: function (newVal) {
          this.$emit('input', newVal)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerDetailGuarantorComponent.vue